import { memo, useMemo } from 'react'
import { Popover } from '@headlessui/react'
import { Issue } from '@app/types'
import { getListHeightSmall } from '@app/components/feed/utils'
import { classNames } from '@app/utils/classes'
import { Link } from '@app/components/stateless/typo/link'

import { FixedSizeList as List } from 'react-window'
import { WithSyntax } from '@app/components/adhoc/with-syntax'
import { Recurrence } from './cells/reccurence'
import { IssueColor } from './cells/issue-color'
import { CodeLink } from './cells/code-link'
import { Selector } from './cells/selector'
import { IssueMessage } from './cells/message'

type CellIssue = Partial<Issue> & {
  hidden?: boolean //the entire section is hidden
  count?: number // if grouping display counter
  pages: Set<string>
}

interface RowProps {
  index: number
  style?: React.CSSProperties
}

// Display issue UI without events
export function FeedIssueCardComponent({
  message,
  code,
  context,
  type: issueType,
  selector,
  recurrence,
  count,
  pages,
  runnerExtras,
}: CellIssue) {
  // todo: only render pages if visible onPress visible set the new state of the list and check if the Length is < than new length to update state again
  const pageList = pages ? [...pages] : []
  const issueCount = pages?.size

  // rec list of urls
  const { size, height } = useMemo(
    () => getListHeightSmall({ fullScreen: false, issueCount }),
    [issueCount]
  )

  // Pages part of list
  const Row = ({ index, style }: RowProps) => {
    const item = pageList[index]

    if (!item) {
      return null
    }

    return (
      <Link
        href={item}
        style={style}
        className='px-2 py-2 block text-sm truncate hover:text-blue-600 border-b'
      >
        {item}
      </Link>
    )
  }

  return (
    <div className='px-3 py-3 flex gap-y-1 flex-col place-content-between h-[inherit]'>
      <div>
        <div className='flex space-x-2 items-center'>
          {typeof count === 'number' && pages ? (
            <Popover className='relative'>
              {({ open }) => (
                <>
                  <Popover.Button
                    className={classNames(
                      'px-2 py-2 text-base font-semibold rounded-xl text-center min-w-[4.1rem] bg-gray-50 dark:bg-gray-900',
                      'focus:text-indigo-600 hover:bg-gray-100 dark:hover:bg-black hover:text-blue-600 focus:hover:text-blue-600',
                      open ? 'bg-gray-200 dark:bg-gray-700 text-blue-600' : ''
                    )}
                    title={`Found ${count} times across the website`}
                  >
                    {count}
                  </Popover.Button>
                  <Popover.Panel className='absolute z-10'>
                    <div className='py-2'>
                      <div className='bg-white dark:bg-black border rounded'>
                        <div className='w-[92vw] lg:max-w-[400px] lg:w-[20vw]'>
                          <List
                            height={height}
                            itemCount={issueCount}
                            itemSize={size}
                            width={'100%'}
                          >
                            {Row}
                          </List>
                        </div>
                      </div>
                    </div>
                  </Popover.Panel>
                </>
              )}
            </Popover>
          ) : null}
          <IssueColor issueType={issueType} />
          <Selector selector={selector} />
          <Recurrence recurrence={recurrence} />
        </div>
        <CodeLink code={code} helpUrl={runnerExtras?.helpUrl} />
      </div>
      <IssueMessage message={message} />
      {context ? <WithSyntax>{context.replaceAll('\n', '')}</WithSyntax> : null}
    </div>
  )
}

export const FeedIssueGroupedCard = memo(FeedIssueCardComponent)
